import {useCallback, useContext, useEffect, useState} from "react";
import TextPlaceholder from "../components/TextPlaceholder";
import {isFieldSelected} from "../utils";
import useEsri from "../hooks/useEsri";
import usePollutantMetric from "../pollutant-metric/usePollutantMetric";
import useForm from "../hooks/useForm";
import useFieldState from "../hooks/useFieldState";
import {InformationCircleIcon} from "@heroicons/react/20/solid";
import {AboutContext} from "./About";

const ComplianceSummary = ({ uniqueCode }) => {
  const { toggleAboutModal } = useContext(AboutContext);
  const {
    onPollutantMetricFieldChange,
    getSelectedYear,
    getSelectedQueryLayer,
  } = useForm();
  const [requestedInfoText, setRequestedInfoText] = useState();
  const [fieldDataState] = useFieldState();
  const { getPollutantMetricItemById, getPollutantMetricUrl } =
    usePollutantMetric();
  const { getComplianceStatus } = useEsri();
  const { areas } = fieldDataState;

  const getAreaItemByCode = useCallback(
    (uniqueCode) => {
      if (!areas[getSelectedQueryLayer]) return;
      return areas[getSelectedQueryLayer].filter(
        (item) => item.id === uniqueCode
      );
    },
    [areas, getSelectedQueryLayer]
  );

  useEffect(() => {
    if (
      !isFieldSelected(uniqueCode) ||
      !isFieldSelected(onPollutantMetricFieldChange)
    ) {
      return;
    }

    setRequestedInfoText(null);
    const { name: pollutant_metric_name, alias: pollutantMetricAlias } =
      getPollutantMetricItemById(onPollutantMetricFieldChange);
    if (getAreaItemByCode(uniqueCode)[0]) {
      const mapPollutantServiceURL =
        getPollutantMetricUrl(pollutantMetricAlias);
      getComplianceStatus(mapPollutantServiceURL, uniqueCode).then(
        (complianceStatus) => {
          const { attributes } = complianceStatus;
          const { name: area_name } = getAreaItemByCode(uniqueCode)[0];
          if (pollutant_metric_name && area_name) {
            setTimeout(
              () =>
                setRequestedInfoText(
                  `${area_name}, ${pollutant_metric_name}, ${attributes.compliance_status} in ${getSelectedYear}.`
                ),
              1000
            );
          }
        }
      );
    }

    return () => {
      /* clean up */
    };
  }, [
    getPollutantMetricItemById,
    getAreaItemByCode,
    getPollutantMetricUrl,
    getSelectedYear,
    getComplianceStatus,
    uniqueCode,
    onPollutantMetricFieldChange,
  ]);

  return (
    <>
      <div
        className="flex items-center pb-2 text-blue-500 hover:text-blue-700 cursor-pointer"
        onClick={toggleAboutModal}
      >
        <InformationCircleIcon className="h-5 w-5 mr-2 text-black" />
        <span>About this compliance map</span>
      </div>
      {requestedInfoText ? (
        <p className="text-gray-700 text-base font-semibold">
          {requestedInfoText}
        </p>
      ) : (
        <div className="min-width-100">
          <TextPlaceholder />
        </div>
      )}
    </>
  );
};

export default ComplianceSummary;

